<template>
  <div>
    <v-dialog :value="value" persistent max-width="600" @input="$emit('input')">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Add contents to &nbsp;<strong>{{ campaignData ? campaignData.name : '' }}</strong>&nbsp;
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" sm="12" lg="12">
              <v-select
                class="mt-5 pt-5"
                :items="postTypes"
                item-text="title"
                item-value="name"
                label="Content Type"
                v-model="postType"
                filled
                hide-details
                @change="changeContentType"
              ></v-select>
            </v-col>
            <!-- <v-col class="mt-0 pt-0" cols="12" md="12" sm="12" lg="12">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click="clickStep(2)" :disabled="!postType">Next</v-btn>
              </v-card-actions>
            </v-col> -->
          </v-row>
          <!-- <v-row>
            <v-col class="pb-0" cols="12" md="12" sm="12" lg="12">
              <v-card-actions class="float-left">
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click="clickStep(1)">Back</v-btn>
              </v-card-actions>
            </v-col>
          </v-row> -->
          <v-expansion-panels class="mt-5" v-model="panel" multiple>
            <!-- <v-expansion-panel v-if="showPanel === 'post'">
              <v-expansion-panel-header>
                <p class="title">Add using Instagram Post URL</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method fill the insights data automatically depend on the availability of the content. You may need to wait a while and then reload page to view the content.</i><br>
                <v-text-field
                  v-model="url"
                  label="Instagram URL"
                  placeholder="Hit Enter to submit"
                  outlined
                  shaped
                  hide-details
                ></v-text-field>
                <div class="mt-2 mb-3 text-right">
                  <v-btn @click="add()">Add</v-btn>
                </div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">URL</th>
                        <th class="text-left">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in list" :key="item.url">
                        <td>
                          <a :href="item.url" target="__blank">{{ item.url }}</a>
                        </td>
                        <td>
                          <v-progress-circular indeterminate color="primary" v-if="item.isLoading"></v-progress-circular>
                          <v-icon color="primary" v-if="!item.isLoading">mdi-thumb-up</v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
            <!-- <v-expansion-panel> Temporary Hide, We will need to apply for a permission
              <v-expansion-panel-header>
                <p class="ma-0 title">Search by Hashtag</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                  <v-btn-toggle color="secondary" v-model="seachHashtagType">
                    <v-btn small>
                      Recent Media
                    </v-btn>
                    <v-btn small>
                      Top Media
                    </v-btn>
                  </v-btn-toggle>
                  <v-text-field
                    height="40"
                    class="mt-5"
                    label="#Hashtag"
                    prefix="#"
                    placeholder="hashtag"
                    outlined
                    v-model="hashtag"
                  ></v-text-field>
                  <v-btn small color="secondary" @click="searchHashTag()"> <v-icon small>mdi-search</v-icon> Search </v-btn>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
            <v-expansion-panel v-if="showPanel === 'story'">
              <v-expansion-panel-header>
                <p class="title">Add Story Insights Manually</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is customised way of adding story insights.</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="6">
                    <!-- <v-text-field
                      prefix="@"
                      v-model.trim="storyIgHandle"
                      label="Influencer"
                      required
                    ></v-text-field> -->
<v-combobox
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      :item-value="getAccountOptionValue"
                      v-if="campaignData.campaignType === campaignTypes.AOK"
                      hide-details="auto"
                      v-model="storyIgHandle"
                      return-object
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                        />
                      </template>
                    </v-combobox>
<v-autocomplete
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      :item-value="getAccountOptionValue"
                      hide-details="auto"
                      v-model="storyIgHandle"
                      return-object
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-else
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="storyCountry"
                      :items="targetCountries"
                      item-text="name"
                      item-value="name"
                      label="Country"
                      outlined
                      dense
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="Story Media URL"
                      v-model.trim="storyMediaUrl"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="storyLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          placeholder="Live Date"
                          v-model="storyLiveDate"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="storyLiveDate"
                        @input="storyLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-btn
                    color="warning"
                    small
                    @click="openUploadStatsDialog(storyIgHandle, 'story')">
                      Upload Stats with AI
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.reach"
                      label="Accounts reached"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.impressions"
                      label="Impressions"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.story_likes"
                      label="Story Likes"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                </v-row>
                <!-- <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.exits"
                      label="Exits"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.taps_back"
                      label="Taps Back"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.taps_forward"
                      label="Taps Forward"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <v-row>
                  
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.replies"
                      label="Replies"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.shares"
                      label="Shares"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.link_clicks"
                      label="Link Clicks"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="storyInsights.sticker_taps"
                      label="Sticker Taps"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addStoryInsightsManually()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'post'">
              <v-expansion-panel-header>
                <p class="title">Add Post Insights Manually</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is customised way of adding post insights.</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="12">
                    <v-col cols="12" md="6">
                      <!-- <v-text-field
                        prefix="@"
                        v-model.trim="postIgHandle"
                        label="Influencer"
                        required
                      ></v-text-field> -->
                      <v-combobox
                        :items="pairedInfluencers"
                        v-if="campaignData.campaignType === campaignTypes.AOK"
                        item-text="instagramHandle"
                        :item-value="getAccountOptionValue"
                        hide-details="auto"
                        v-model="postIgHandle"
                        return-object
                        label="Influencers"
                        prefix="@"
                        dense
                        outlined
                      >
                        <template v-slot:selection="{ item }">
                          <span v-if="item.platform === 'xiaohongshu'">
                            {{item.fullName}}
                          </span>
                          <span v-else-if="item.instagramHandle">
                            {{item.instagramHandle}}
                          </span>
                          <span v-else>
                            {{item}}
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <social-handle-view
                            divClassName="d-inline"
                            :isTikTok="item.platform === 'tiktok'"
                            :isInstagram="!item.platform || item.platform === 'instagram'"
                            :isYoutube="item.platform === 'youtube'"
                            :isFacebook="item.platform === 'facebook'"
                            :isLinkedIn="item.platform === 'linkedin'"
                            :isXiaohongshu="item.platform === 'xiaohongshu'"
                            :tiktokHandle="item.instagramHandle"
                            :instagramHandle="item.instagramHandle"
                            :youtubeHandle="item.instagramHandle"
                            :facebookHandle="item.instagramHandle"
                            :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                            :xiaohongshuHandle="item.fullName"
                            :isOthers="item.platform === 'others'"
                            :otherHandle="item.instagramHandle"
                          />
                        </template>
                      </v-combobox>
                      <v-autocomplete
                        :items="pairedInfluencers"
                        item-text="instagramHandle"
                        :item-value="getAccountOptionValue"
                        hide-details="auto"
                        v-model="postIgHandle"
                        return-object
                        label="Influencers"
                        prefix="@"
                        dense
                        outlined
                        v-else
                      >
                        <template v-slot:selection="{ item }">
                          <span v-if="item.platform === 'xiaohongshu'">
                            {{item.fullName}}
                          </span>
                          <span v-else-if="item.instagramHandle">
                            {{item.instagramHandle}}
                          </span>
                          <span v-else>
                            {{item}}
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <social-handle-view
                            divClassName="d-inline"
                            :isTikTok="item.platform === 'tiktok'"
                            :isInstagram="!item.platform || item.platform === 'instagram'"
                            :isYoutube="item.platform === 'youtube'"
                            :isFacebook="item.platform === 'facebook'"
                            :isLinkedIn="item.platform === 'linkedin'"
                            :isXiaohongshu="item.platform === 'xiaohongshu'"
                            :tiktokHandle="item.instagramHandle"
                            :instagramHandle="item.instagramHandle"
                            :youtubeHandle="item.instagramHandle"
                            :facebookHandle="item.instagramHandle"
                            :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                            :xiaohongshuHandle="item.fullName"
                            :isOthers="item.platform === 'others'"
                            :otherHandle="item.instagramHandle"
                          />
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        v-model="postCountry"
                        :items="targetCountries"
                        item-text="name"
                        item-value="name"
                        label="Country"
                        dense
                        outlined
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                  <v-autocomplete
                    v-model="postCountry"
                    :items="targetCountries"
                    item-text="name"
                    item-value="code"
                    label="Country"
                    dense
                  >
                  </v-autocomplete>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="Post URL"
                      v-model.trim="postURL"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="Post Image URL"
                      placeholder="Optional"
                      v-model.trim="postImageURL"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="postLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="postLiveDate"
                          placeholder="Live Date"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="postLiveDate"
                        @input="postLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-btn
                    color="warning"
                    small
                    @click="openUploadStatsDialog(postIgHandle, 'post')">
                      Upload Stats with AI
                    </v-btn>
                  </v-col>
                </v-row>
                <div v-if="postType === 'IGP' || postType === 'IGC'">
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="inputtedInsights.reach"
                        label="Accounts reached"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="inputtedInsights.impressions"
                        label="Impressions"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <!-- <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="postInsights.engagement_rate"
                        label="Engagement Rate"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="postInsights.outreach"
                        label="Outreach"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col> -->

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="postInsights.like_count"
                        label="Likes"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                      v-model.number="inputtedInsights.shares"
                      label="Shares"
                      required
                      type="number"
                    ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="postInsights.comment_count"
                        label="Comments"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="inputtedInsights.saved"
                        label="Saves (Bookmarks)"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="postType === 'IGR'">
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="inputtedInsights.reach"
                        label="Accounts reached"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="inputtedInsights.views"
                        label="Plays (Views)"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <!-- <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="postInsights.engagement_rate"
                        label="Engagement Rate"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="postInsights.outreach"
                        label="Outreach"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col> -->

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="postInsights.like_count"
                        label="Likes"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="inputtedInsights.saved"
                        label="Saves (Bookmarks)"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="inputtedInsights.shares"
                        label="Shares"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="inputtedInsights.reposts"
                        label="Reposts"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model.number="postInsights.comment_count"
                        label="Comments"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-layout wrap>
                        <v-flex xs12 md12 class="ma-0 pa-0" style="margin-top: -3px!important;margin-bottom:-45px!important">
                          <label style="font-weight: normal;font-size: 12px;color: rgba(0, 0, 0, 0.6);">Watch Time</label>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap>
                        <v-flex xs3 md3 lg3>
                          <v-text-field
                          v-model="reelTotalPlayTime.day"
                          label="d"
                          required
                          type="number"
                          min="0"
                        ></v-text-field>
                        </v-flex>
                        <v-flex xs3 md3 lg3>
                          <v-text-field
                          v-model="reelTotalPlayTime.hour"
                          label="h"
                          required
                          type="number"
                          min="0"
                        ></v-text-field>
                        </v-flex>
                        <v-flex xs3 md3 lg3>
                          <v-text-field
                            v-model="reelTotalPlayTime.minute"
                            label="m"
                            required
                            type="number"
                            min="0"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3 md3 lg3>
                          <v-text-field
                            v-model="reelTotalPlayTime.second"
                            label="s"
                            required
                            type="number"
                            min="0"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="inputtedInsights.watches"
                        label="Average Watch Time"
                        required
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addPostInsightsManually()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'tiktok'">
              <v-expansion-panel-header>
                <p class="title">Add using TikTok URL</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is semi-customised way of adding Tiktok insights.</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="6">
                    <!-- <v-text-field
                      prefix="@"
                      v-model.trim="tikTokHandle"
                      label="Influencer"
                      required
                    ></v-text-field> -->
<v-combobox
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      :item-value="getAccountOptionValue"
                      hide-details="auto"
                      v-model="tikTokHandle"
                      return-object
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-if="campaignData.campaignType === campaignTypes.AOK"
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-combobox>
<v-autocomplete
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      :item-value="getAccountOptionValue"
                      hide-details="auto"
                      v-model="tikTokHandle"
                      return-object
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-else
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="tiktokCountry"
                      :items="targetCountries"
                      item-text="name"
                      item-value="name"
                      label="Country"
                      dense
                      outlined
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="Post URL"
                      v-model.trim="tikTokPostURL"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="tiktokLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          placeholder="Live Date"
                          v-model="tiktokLiveDate"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="tiktokLiveDate"
                        @input="tiktokLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInsights.like_count"
                      label="Likes"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInsights.comment_count"
                      label="Comments"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <!-- <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.views"
                      label="Views"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-btn
                    color="warning"
                    small
                    @click="openUploadStatsDialog(tikTokHandle, 'tiktok')">
                      Upload Stats with AI
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-layout wrap>
                      <v-flex xs12 md12 class="ma-0 pa-0" style="margin-top: -3px!important;margin-bottom:-45px!important">
                        <label style="font-weight: normal;font-size: 12px;color: rgba(0, 0, 0, 0.6);">Total Play Time</label>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs4 md4 lg4>
                        <v-text-field
                        v-model="totalPlayTime.hour"
                        label="h"
                        required
                        type="number"
                        min="0"
                      ></v-text-field>
                      </v-flex>
                      <v-flex xs4 md4 lg4>
                        <v-text-field
                          v-model="totalPlayTime.minute"
                          label="m"
                          required
                          type="number"
                          min="0"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 md4 lg4>
                        <v-text-field
                          v-model="totalPlayTime.second"
                          label="s"
                          required
                          type="number"
                          min="0"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-col>
                  <!-- <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.reach"
                      label="Reach"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.impressions"
                      label="Impressions"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col> -->
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="tikTokInputtedInsights.watches"
                      label="Average Watch Time"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInsights.like_count"
                      label="Likes"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInsights.comment_count"
                      label="Comments"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInsights.shares"
                      label="Shares"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.saved"
                      label="Favourites (Bookmarks)"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInsights.views"
                      label="Plays (Views)"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.reach"
                      label="Total viewers (Reach)"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.watchedFullVideo"
                      label="Watched full video (%)"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.photo_views"
                      label="Photo Views"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addTikTokInsightsManually()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'youtube'">
              <v-expansion-panel-header>
                <p class="title">Add using Youtube URL</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is customised way of adding Youtube insights.</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="6">
                    <!-- <v-text-field
                      prefix="@"
                      v-model.trim="youtubeHandle"
                      label="Influencer"
                      required
                    ></v-text-field> -->
                    <v-combobox
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-if="campaignData.campaignType === campaignTypes.AOK"
                      v-model="youtubeHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-combobox>
                    <v-autocomplete
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="youtubeHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-else
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="youtubeCountry"
                      :items="targetCountries"
                      item-text="name"
                      item-value="name"
                      label="Country"
                      dense
                      outlined
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="Youtube Video URL"
                      v-model.trim="youtubeURL"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="youtubeLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="youtubeLiveDate"
                          placeholder="Live Date"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="youtubeLiveDate"
                        @input="youtubeLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="youtubeInsights.like_count"
                      label="Likes"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="youtubeInsights.comment_count"
                      label="Comments"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="youtubeInsights.views"
                      label="Views"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="youtubeInputtedInsights.impressions"
                      label="Impressions"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="youtubeInputtedInsights.unique_viewers"
                      label="Unique Viewers"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="youtubeInputtedInsights.watches"
                      label="Average Watch Time"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addYoutubeInsightsManually()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'Others' || showPanel === 'LinkedIn Post' || showPanel === 'X (Twitter) Post'">
              <v-expansion-panel-header>
                <p class="title">Add using {{ showPanel === 'LinkedIn Post' ? 'LinkedIn' : (showPanel === 'X (Twitter) Post' ? 'X (Twitter)' : 'Others') }} URL</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is a customised way of adding {{ showPanel === 'LinkedIn Post' ? 'LinkedIn' : (showPanel === 'X (Twitter) Post' ? 'X (Twitter)' : 'other platform') }} insights.</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="6">
                    <!-- <v-text-field
                      prefix="@"
                      v-model.trim="otherHandle"
                      label="Influencer"
                      required
                    ></v-text-field> -->
                    <v-combobox
                      :items="otherInfluencers"
                      item-text="displayHandle"
                      item-value="displayHandle"
                      return-object
                      :loading="pairedInfluencersLoading"
                      v-if="campaignData.campaignType === campaignTypes.AOK"
                      hide-details="auto"
                      v-model="otherHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.displayHandle">
                          {{item.displayHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isTwitter="item.platform === 'twitter'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :twitterHandle="item.twitterHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-combobox>
                    <v-autocomplete
                      :items="otherInfluencers"
                      item-text="displayHandle"
                      item-value="displayHandle"
                      return-object
                      :loading="pairedInfluencersLoading"
                      hide-details="auto"
                      v-model="otherHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-else
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.displayHandle">
                          {{item.displayHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isTwitter="item.platform === 'twitter'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :twitterHandle="item.twitterHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="otherCountry"
                      :items="targetCountries"
                      item-text="name"
                      item-value="name"
                      label="Country"
                      dense
                      outlined
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="Post URL"
                      v-model.trim="otherPostURL"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <!-- <v-text-field
                      label="XHS Media URL"
                      v-model.trim="xhsMediaUrl"
                    ></v-text-field> -->
                    <upload-media
                    accept="*" 
                    @change="otherMediaChanged" 
                    :listMedia="media"
                    :influencer="influencer"
                    :campaign="campaignData"></upload-media>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="otherLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          placeholder="Live Date"
                          v-model="otherLiveDate"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="otherLiveDate"
                        @input="otherLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInsights.like_count"
                      label="Likes"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInsights.comment_count"
                      label="Comments"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <!-- <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.views"
                      label="Views"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col
                    v-if="showPanel !== 'LinkedIn Post' && showPanel !== 'X (Twitter) Post'"
                    cols="12"
                    md="6"
                  >
                    <v-layout wrap>
                      <v-flex xs12 md12 class="ma-0 pa-0" style="margin-top: -3px!important;margin-bottom:-45px!important">
                        <label style="font-weight: normal;font-size: 12px;color: rgba(0, 0, 0, 0.6);">Total Play Time</label>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs4 md4 lg4>
                        <v-text-field
                          v-model="otherTotalPlayTime.hour"
                        label="h"
                        required
                        type="number"
                        min="0"
                      ></v-text-field>
                      </v-flex>
                      <v-flex xs4 md4 lg4>
                        <v-text-field
                          v-model="otherTotalPlayTime.minute"
                          label="m"
                          required
                          type="number"
                          min="0"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 md4 lg4>
                        <v-text-field
                          v-model="otherTotalPlayTime.second"
                          label="s"
                          required
                          type="number"
                          min="0"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-col>
                  <!-- <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.reach"
                      label="Reach"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="tikTokInputtedInsights.impressions"
                      label="Impressions"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col> -->
                  <v-col
                    v-if="showPanel !== 'LinkedIn Post' && showPanel !== 'X (Twitter) Post'"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="otherInsights.watches"
                      label="Average Watch Time"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="showPanel === 'LinkedIn Post'" cols="12" class="pb-0">
                    <div class="subtitle-1 font-weight-bold">Discovery</div>
                  </v-col>
                  <v-col
                    v-if="showPanel === 'LinkedIn Post' || showPanel === 'X (Twitter) Post'"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="otherInsights.impressions"
                      label="Impressions"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="showPanel === 'LinkedIn Post'"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="otherInsights.reach"
                      label="Members reached"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="showPanel === 'LinkedIn Post'" cols="12" md="6">
                    <div class="subtitle-1 font-weight-bold mb-2">Video Performance</div>
                    <v-text-field
                      v-model.number="otherInsights.video_views"
                      label="Video views"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="showPanel === 'LinkedIn Post'" cols="12" md="6">
                    <div class="subtitle-1 font-weight-bold mb-2">Profile Activity</div>
                    <v-text-field
                      v-model.number="otherInsights.profile_viewers"
                      label="Profile viewers from this post"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="showPanel === 'LinkedIn Post'" cols="12" class="pb-0">
                    <div class="subtitle-1 font-weight-bold">Engagement</div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="otherInsights.like_count"
                      :label="showPanel === 'LinkedIn Post' ? 'Reactions' : 'Likes'"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="otherInsights.comment_count"
                      :label="showPanel === 'X (Twitter) Post' ? 'Replies' : 'Comments'"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="otherInsights.shares"
                      :label="showPanel === 'LinkedIn Post' || showPanel === 'X (Twitter) Post' ? 'Reposts' : 'Shares'"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="otherInsights.saved"
                      :label="showPanel === 'LinkedIn Post' ? 'Saves' : (showPanel === 'X (Twitter) Post' ? 'Bookmarks' : 'Favourites (Bookmarks)')"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="showPanel !== 'LinkedIn Post' && showPanel !== 'X (Twitter) Post'"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="otherInsights.views"
                      :label="showPanel === 'X (Twitter) Post' ? 'Views' : 'Plays (Views)'"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="showPanel !== 'LinkedIn Post' && showPanel !== 'X (Twitter) Post'"
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model.number="otherInsights.reach"
                      label="Total viewers (Reach)"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addOtherInsightsManually()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'Facebook Post'">
              <v-expansion-panel-header>
                <p class="title">Add Facebook Insights Manually</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is customised way of adding facebook insights.</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="6">
                    <!-- <v-text-field
                      prefix="@"
                      v-model.trim="fbHandle"
                      label="Influencer"
                      required
                    ></v-text-field> -->
                    <v-combobox
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="fbHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-if="campaignData.campaignType === campaignTypes.AOK"
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-combobox>
                    <v-autocomplete
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="fbHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-else
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="fbCountry"
                      :items="targetCountries"
                      item-text="name"
                      item-value="name"
                      label="Country"
                      dense
                      outlined
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="Facebook Media URL"
                      v-model.trim="fbMediaUrl"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="fbLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          placeholder="Live Date"
                          v-model="fbLiveDate"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="fbLiveDate"
                        @input="fbLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="fbInsights.outreach"
                      label="Outreach"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="fbInsights.like_count"
                      label="Likes"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="fbInsights.comment_count"
                      label="Comments"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="fbInsights.views"
                      label="Views"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="fbInsights.shares"
                      label="Shares"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="fbInsights.bookmarks"
                      label="Bookmarks"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addFbInsightsManually()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'XHS Post'">
              <v-expansion-panel-header>
                <p class="title">Add XHS Insights Manually</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is customised way of adding XHS insights.</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="6">
                    <!-- <v-text-field
                      prefix="@"
                      v-model.trim="xhsHandle"
                      label="Influencer"
                      required
                    ></v-text-field> -->
                    <v-combobox
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="xhsHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-if="campaignData.campaignType === campaignTypes.AOK"
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-combobox>
                    <v-autocomplete
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="xhsHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-else
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="xhsCountry"
                      :items="targetCountries"
                      item-text="name"
                      item-value="name"
                      label="Country"
                      dense
                      outlined
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="XHS Link"
                      v-model.trim="xhsLink"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <!-- <v-text-field
                      label="XHS Media URL"
                      v-model.trim="xhsMediaUrl"
                    ></v-text-field> -->
                    <upload-media
                    accept="*" 
                    @change="xhsMediaChanged" 
                    :listMedia="media"
                    :influencer="influencer"
                    :campaign="campaignData"></upload-media>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="xhsLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          placeholder="Live Date"
                          v-model="xhsLiveDate"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="xhsLiveDate"
                        @input="xhsLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      type="number"
                      label="Followers"
                      v-model.trim="xhsFollowers"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="xhsInsights.outreach"
                      label="Outreach"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col> -->
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="xhsInsights.views"
                      label="Views"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="xhsInsights.watches"
                      label="Average Watch Time"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="xhsInsights.like_count"
                      label="Likes"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="xhsInsights.bookmarks"
                      label="Saves"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="xhsInsights.comment_count"
                      label="Comments"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="xhsInsights.shares"
                      label="Shares"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addXHSInsightsManually()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'Lemon Post'">
              <v-expansion-panel-header>
                <p class="title">Add Lemon8 Insights Manually</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is customised way of adding XHS insights.</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="6">
                    <!-- <v-text-field
                      prefix="@"
                      v-model.trim="xhsHandle"
                      label="Influencer"
                      required
                    ></v-text-field> -->
                    <v-combobox
                      :items="pairedInfluencers"
                      v-if="campaignData.campaignType === campaignTypes.AOK"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="lemonHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'lemon8'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-combobox>
                    <v-autocomplete
                      v-else
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="lemonHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'lemon8'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="lemonCountry"
                      :items="targetCountries"
                      item-text="name"
                      item-value="name"
                      label="Country"
                      dense
                      outlined
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      label="Lemon8 Link"
                      v-model.trim="lemonLink"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <!-- <v-text-field
                      label="XHS Media URL"
                      v-model.trim="xhsMediaUrl"
                    ></v-text-field> -->
                    <upload-media
                    accept="*" 
                    @change="lemonMediaChanged" 
                    :listMedia="media"
                    :influencer="influencer"
                    :campaign="campaignData"></upload-media>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="lemonLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          placeholder="Live Date"
                          v-model="lemonLiveDate"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="lemonLiveDate"
                        @input="lemonLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-text-field
                      type="number"
                      label="Followers"
                      v-model.trim="lemonFollowers"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="lemonInsights.outreach"
                      label="Outreach"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col> -->
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="lemonInsights.views"
                      label="Views"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="lemonInsights.watches"
                      label="Average Watch Time"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="lemonInsights.like_count"
                      label="Likes"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="lemonInsights.bookmarks"
                      label="Saves"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="lemonInsights.comment_count"
                      label="Comments"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model.number="lemonInsights.shares"
                      label="Shares"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addLemonInsightsManually()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'story'">
              <v-expansion-panel-header>
                <p class="title">Add Multiple Contents</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is to upload multiple contents without full insights data. (Can update the insights after uploaded)</i><br>
                <v-row class="mt-1" align="center" justify="center">
                  <v-col cols="12" md="6">
                    <v-combobox
                      v-if="campaignData.campaignType === campaignTypes.AOK"
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="multipleIgHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-combobox>
                    <v-autocomplete
                      :items="pairedInfluencers"
                      item-text="instagramHandle"
                      item-value="instagramHandle"
                      hide-details="auto"
                      v-model="multipleIgHandle"
                      label="Influencers"
                      prefix="@"
                      dense
                      outlined
                      v-else
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.platform === 'xiaohongshu'">
                          {{item.fullName}}
                        </span>
                        <span v-else-if="item.instagramHandle">
                          {{item.instagramHandle}}
                        </span>
                        <span v-else>
                          {{item}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <social-handle-view
                          divClassName="d-inline"
                          :isTikTok="item.platform === 'tiktok'"
                          :isInstagram="!item.platform || item.platform === 'instagram'"
                          :isYoutube="item.platform === 'youtube'"
                          :isFacebook="item.platform === 'facebook'"
                          :isLinkedIn="item.platform === 'linkedin'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :linkedinHandle="item.linkedinHandle || item.instagramHandle"
                          :xiaohongshuHandle="item.fullName"
                          :isOthers="item.platform === 'others'"
                          :otherHandle="item.instagramHandle"
                        />
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="multipleCountry"
                      :items="targetCountries"
                      item-text="name"
                      item-value="name"
                      label="Country"
                      hide-details
                      dense
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                  >
                    <v-menu
                      ref="datePicker"
                      v-model="multipleLiveCal"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          placeholder="Live Date"
                          v-model="multipleLiveDate"
                          append-icon="event"
                          readonly
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        type="date"
                        v-model="multipleLiveDate"
                        @input="multipleLiveCal = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    xs="12"
                    class="text-center"
                  >
                    <!-- <GDriveSelector @picked="gDrivePicked" /> -->
                    <!-- <v-btn color="secondary" @click="openCloudinaryUpload">
                      Choose File(s)
                    </v-btn> -->
                    <upload-media 
                    accept="*" 
                    @change="mediaChanged" 
                    :listMedia="media"
                    :influencer="influencer"
                    :campaign="campaignData"></upload-media>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12"
                  md="6"
                  xs="6"
                  :key="index" v-for="(gd, index) in gdriveFiles">
                    <v-btn
                      @click.stop="deletegDriveFile(index)"
                      color="error" class="ims-action btn-gdrive-del"
                      small
                    >
                      <v-icon small>close</v-icon>
                    </v-btn>
                    <iframe class="media-iframe" width="100%" height="100%" :src="gd.embedURL" allowFullScreen></iframe>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="saveMutlipleContents()">Add</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="showPanel === 'post'">
              <v-expansion-panel-header>
                <p class="title">Add using Instagram Graph API</p>
                <p class="subtitle">(Recommended)</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <i class="subtitle">This method is officially supported by Instagram. It is required approved permissions from the influencers who logged in via Facebook.</i><br>
                <v-text-field height="30px" class="mb-5" prefix="@" hide-details placeholder="Filter by instagram handle"></v-text-field>
                <v-chip
                  outlined
                  pill
                  small
                  class="ma-1"
                  color="primary"
                  @click="showRecentPosts(influencer.instagramHandle)"
                  v-for="(influencer, index) of pairedInfluencers"
                  :key="index"
                  label
                >
                  <v-icon small left>mdi-instagram</v-icon>
                  {{ influencer.fullName }}({{ influencer.instagramHandle }})
                </v-chip>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="close()" :disabled="loading">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Loading :dialog="loading" />
    <PostView
      :selectedPostIds="selectedPostIds"
      @onSelect="postSelected"
      @prev_page="showRecentPosts(selectedInstagramHandle, 'prev')"
      @next_page="showRecentPosts(selectedInstagramHandle, 'next')"
      :value="recentPostDialog"
      :title="postListTitle"
      :posts="listPosts"
      v-model="recentPostDialog"
    />
    <upload-stats-modal
    v-model="uploadStatsDialog"
    :value="uploadStatsDialog"
    :postType="aiPostType"
    :imagesToView="campaignPayout"
    @statsConfirmed="confirmedStats"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PostView from './PostView';
import Loading from '@/components/core/Loading';
import campaignAPIs from '@/components/views/Campaign/campaignAPIs';
import campaignHelper from '@/components/views/Campaign/campaignHelper';
import postAPIs from '@/components/views/Post/postApi';
import pairingAPIs from '@/components/views/Pairing/pairingAPIs';
import instagramAPIs from '@/components/views/Instagram/instagramAPIs';
import utils from '@/utils';
import config from '@/config';
import campaignConfig from '@/components/views/Campaign/config';
import GDriveSelector from '../gdrive/GDriveSelector';
import UploadMedia from '../post/UploadMedia';
import influencerAPIs from '../../views/Influencer/influencerAPIs';
import SocialHandleView from '@/components/scoped/custom/SocialHandleView'
import countries from '../../../../static/sources/countries';
import UploadStatsModal from './UploadStatsModal.vue';
export default {
  name: 'AddPostToCampaign',
  components: {
    PostView,
    Loading,
    GDriveSelector,
    UploadMedia,
    SocialHandleView,
    UploadStatsModal
  },
  props: {
    campaign: Object,
    value: Boolean,
    selectedPostIds: Object, // hashmap
    postID: String,
    post: Object,
    campaignPayouts: Object
  },
  data() {
    return {
      cldConfig: config.cldConfig,
      payoutStatus: campaignConfig.payoutStatus,
      campaignTypes: campaignConfig.campaignType,
      countries,
      step: 1,
      showPanel: '',
      recentPostDialog: false,
      loading: false,
      campaignData: null,
      noOfnewPostAdded: 0,
      paging: null,
      seachHashtagType: 0, // Default is recent media
      list: [],
      url: null,
      // search by hashtag or by influencer search
      postViewType: 'influencer_search', // Enum('influencer_search', hashtag_search)
      pairedInfluencers: [],
      pairedInfluencersLoading: false,
      xhsInfluencers: [],
      fbInfluencers: [],
      selectedInstagramHandle: null,
      postListTitle: null,
      listPosts: [],
      hashtag: null,
      // Story Insights
      storyIgHandle: '',
      storyCountry: '',
      storyLiveDate: '',
      storyLiveCal: false,
      postLiveDate: '',
      postLiveCal: false,
      tiktokLiveDate: '',
      tiktokLiveCal: false,
      multipleLiveDate: '',
      multipleLiveCal: false,
      otherLiveDate: '',
      otherLiveCal: false,
      uploadStatsDialog: false,
      campaignPayout: null,
      aiPostType: '',
      storyInsights: {
        impressions: '',
        story_likes: '',
        reach: '',
        replies: '',
        exits: '',
        taps_back: '',
        taps_forward: '',
        shares: '',
        link_clicks: '',
        sticker_taps: ''
      },
      // Facebook
      fbHandle: '',
      fbCountry: '',
      fbMediaUrl: '',
      fbLiveDate: '',
      fbLiveCal: false,
      fbInsights: {
        outreach: '',
        like_count: '',
        comment_count: '',
        views: '',
        shares: '',
        bookmarks: ''
      },
      // XHS
      xhsHandle: '',
      xhsCountry: '',
      xhsID: '',
      xhsMediaUrl: [],
      xhsFullname: '',
      xhsLink: '',
      xhsFollowers: '',
      xhsLiveDate: '',
      xhsLiveCal: false,
      xhsInsights: {
        outreach: '',
        like_count: '',
        comment_count: '',
        views: '',
        watches: '',
        shares: '',
        bookmarks: ''
      },
      // Lemon 8
      lemonHandle: '',
      lemonCountry: '',
      lemonID: '',
      lemonMediaUrl: [],
      lemonFullname: '',
      lemonLink: '',
      lemonFollowers: '',
      lemonLiveDate: '',
      lemonLiveCal: false,
      lemonInsights: {
        outreach: '',
        like_count: '',
        comment_count: '',
        views: '',
        watches: '',
        shares: '',
        bookmarks: ''
      },
      // end of XHS
      postTypes: campaignHelper.getDeliverableNames(),
      postType: '',
      postIgHandle: '',
      postCountry: '',
      postURL: '',
      postImageURL: '',
      postInsights: {
        engagement_rate: '',
        outreach: '',
        like_count: '',
        comment_count: ''
      },
      inputtedInsights: {
        saved: '',
        shares: '',
        reposts: '',
        views: '',
        reach: '',
        impressions: '',
        watches: '',
        plays: ''
      },
      tikTokHandle: '',
      tiktokCountry: '',
      tikTokPostURL: '',
      tikTokInsights: {
        engagement_rate: '',
        outreach: '',
        like_count: '',
        comment_count: '',
        views: '',
        shares: ''
      },
      tikTokInputtedInsights: {
        outreach: '',
        engagement_rate: '',
        reach: '',
        impressions: '',
        watches: '',
        plays: '',
        watchedFullVideo: '',
        photo_views: ''
      },
      // Others
      otherHandle: '',
      otherCountry: '',
      otherPostURL: '',
      otherMediaUrl: [],
      otherInsights: {
        engagement_rate: '',
        outreach: '',
        like_count: '',
        comment_count: '',
        impressions: '',
        views: '',
        shares: '',
        reach: '',
        saved: '',
        watches: '',
        plays: '',
        video_views: '',
        profile_viewers: ''
      },
      otherTotalPlayTime: {
        hour: '',
        minute: '',
        second: ''
      },
      // youtube
      youtubeHandle: '',
      youtubeCountry: '',
      youtubeURL: '',
      youtubeInsights: {
        outreach: '',
        engagement_rate: '',
        like_count: '',
        comment_count: '',
        views: ''
      },
      youtubeInputtedInsights: {
        impressions: '',
        unique_viewers: '',
        watches: ''
      },
      youtubeLiveDate: '',
      youtubeLiveCal: false,
      multipleIgHandle: '',
      gdriveFiles: [],
      panel: [],
      media: [],
      totalPlayTime: {
        hour: '',
        minute: '',
        second: ''
      },
      reelTotalPlayTime: {
        day: '',
        hour: '',
        minute: '',
        second: ''
      }
    };
  },
  computed: {
    ...mapState({
      cldSignature: state => state.campaign.cldSignature
    }),
    isDone() {
      let done = this.list.filter(item => !item.isLoading);
      return done.length === 0;
    },
    postTypeName() {
      return campaignHelper.getDeliverableTitle(this.postType)
    },
    otherInfluencers() {
      return this.pairedInfluencers
    }
  },
  methods: {
    parsePlayTime(playTime) {
      const timeArray = [];
      let days = 0
      let hours = 0
      let minutes = 0
      let seconds = 0
      // Split the playTime string into parts
      let currentNum = '';
      for (let i = 0; i < playTime.length; i++) {
        const char = playTime[i];
        // If the character is a digit, build the current number
        if (!isNaN(char)) {
          currentNum += char;
        } else {
          // If we reach a letter, we know we've completed a number
          if (currentNum) {
            if (char === 'd') {
              days = parseInt(currentNum, 10);
            } else if (char === 'h') {
              hours = parseInt(currentNum, 10);
            } else if (char === 'm') {
              minutes = parseInt(currentNum, 10);
            } else if (char === 's') {
              seconds = parseInt(currentNum, 10);
            }
            currentNum = ''; // Reset for the next number
          }
        }
      }
      // Push the results into the array
      timeArray.push(days, hours, minutes, seconds);
      return timeArray;
    },
    showRecentPosts(instagramHandle, page) {
      let after, before;
      if (page === 'prev') {
        before = this.paging ? this.paging.cursors.previous : null;
      }
      if (page === 'next') {
        after = this.paging ? this.paging.cursors.after : null;
      }
      this.fetchRecentPosts(instagramHandle, after, before)
        .then(data => {
          this.recentPostDialog = true;
          this.listPosts = data.medias;
          this.paging = data.paging;
          this.postListTitle = `${instagramHandle}'s Recent Posts`;
          this.postViewType = 'influencer_search';
        })
        .catch(() => {
          this.$swal({
            type: 'warning',
            text: 'Some thing wrong. Cannot perform this action'
          });
        });
      this.selectedInstagramHandle = instagramHandle;
    },
    async fetchRecentPosts(instagramhandle, after, before) {
      try {
        const resp = await instagramAPIs.fetchRecentPosts(instagramhandle, after, before);
        return resp || {};
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    searchHashTag() {
      const searchType = this.seachHashtagType === 0 ? 'recent_media' : 'top_media';
      this.fetchPostByHashtag(this.hashtag, searchType)
        .then(posts => {
          this.recentPostDialog = true;
          this.listPosts = posts;
          this.postViewType = 'hashtag_search';
          this.postListTitle = `Posts published with tag ${this.hashtag}`;
        })
        .catch(err => {
          console.error(err);
          this.$swal({
            type: 'warning',
            text: 'Some thing wrong. Cannot perform this action'
          });
        });
    },
    async fetchPostByHashtag(hashtag, type) {
      try {
        const resp = await instagramAPIs.searchByHashtag({ hashtag, type });
        return resp.data || [];
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    userRecentPostDialog() {
      this.recentPostDialog = false;
    },
    close() {
      // this.$emit('done');
      this.$emit('input');
    },
    add() {
      if (this.url === '' || this.url === null) {
        this.$swal({
          type: 'error',
          title: 'Empty URL',
          text: 'Please Enter the correct URL'
        });
      } else {
        let data = {
          isLoading: true,
          url: this.url,
          shortcode: utils.func.extractShortCode(this.url)
        };
        this.list.push(data);
        this.url = '';
        this.addPostToCampaign(data.url, this.campaignData.id);
      }
    },
    async fetchSelectedInfluencers(campaignId) {
      try {
        let resp = await pairingAPIs.getPairedInfluencersByCampaign(campaignId);
        const acceptedPairings = resp.filter(pairing => {
          const pairingStatus = pairing.pairing_details && pairing.pairing_details.status
          return Number(pairingStatus) === Number(config.pairingStatus.ACCEPTED)
        })
        // const influencers = resp
        //   .map(e => e.influencer_details)
        //   .map(e => {
        //     return {
        //       fullName: e.fullname,
        //       instagramHandle: e.instagramHandle,
        //       platform: e.platform || 'instagram',
        //       instagramID: e.instagramID,
        //       influencerID: e.influencerID
        //     };
        //   });
        const influencers = acceptedPairings.map(e => {
          let result = {}
          if (e.influencer_details) {
            let infDetails = e.influencer_details
            const rawPlatform = String(infDetails.platform || 'instagram').toLowerCase()
            const platform = rawPlatform === 'x' ? 'twitter' : rawPlatform
            const linkedinHandle = infDetails.linkedinHandle ||
              (platform === 'linkedin' ? (infDetails.userHandle || infDetails.instagramHandle) : '')
            const twitterHandle = infDetails.twitterHandle ||
              (platform === 'twitter' ? (infDetails.userHandle || infDetails.instagramHandle) : '')
            const displayHandle = platform === 'linkedin'
              ? linkedinHandle
              : (platform === 'twitter' ? twitterHandle : infDetails.instagramHandle)
            const deliverables = e.deliverables_details || {}
            result = {
              pairingID: e.id,
              fullName: infDetails.fullname || infDetails.fullName,
              // Legacy selectors use instagramHandle as their common option value for every platform.
              originalInstagramHandle: infDetails.instagramHandle,
              instagramHandle: displayHandle || infDetails.instagramHandle || twitterHandle || linkedinHandle || infDetails.fullname || infDetails.fullName,
              instagramAccountHandle: infDetails.igHandle || (platform === 'instagram' ? infDetails.instagramHandle : ''),
              tiktokHandle: infDetails.tiktokHandle || (platform === 'tiktok' ? (infDetails.userHandle || infDetails.instagramHandle) : ''),
              youtubeAccountHandle: infDetails.youtubeHandle || (platform === 'youtube' ? (infDetails.userHandle || infDetails.instagramHandle) : ''),
              facebookAccountHandle: infDetails.facebookHandle || infDetails.fbHandle || (platform === 'facebook' ? (infDetails.userHandle || infDetails.instagramHandle) : ''),
              linkedinHandle,
              twitterHandle,
              xhsHandle: infDetails.xhsHandle || (platform === 'xiaohongshu' ? (infDetails.userHandle || infDetails.instagramHandle || infDetails.fullName) : ''),
              displayHandle: displayHandle || infDetails.instagramHandle || twitterHandle || linkedinHandle || infDetails.fullname || infDetails.fullName,
              platform,
              hasLinkedInDeliverable: platform === 'linkedin' || Number(deliverables.no_of_li_posts || 0) > 0,
              hasTwitterDeliverable: platform === 'twitter' || Number(deliverables.no_of_x_posts || 0) > 0,
              xhsID: infDetails.xhsID || '',
              instagramID: infDetails.instagramID,
              influencerID: infDetails.influencerID
            }
          }
          if (e.payout_details) {
            result.payoutStatus = e.payout_details.status
          }
          return result
        })
        this.pairedInfluencers = await this.expandPairedInfluencerHandles(influencers)
        // this.xhsInfluencers = this.pairedInfluencers.filter(p => p.platform === 'xiaohongshu')
        // this.fbInfluencers = this.pairedInfluencers.filter(p => p.platform === 'facebook')
      } catch (error) {
        console.error(error);
      }
    },
    getInfluencerProfileHandles(profile, pairedInfluencer) {
      const nestedHandle = (key, handleKey) => profile && profile[key] && profile[key][handleKey]
      const accounts = [
        { platform: 'instagram', handle: profile.instagramHandle || nestedHandle('instagram', 'instagramHandle') || pairedInfluencer.instagramAccountHandle },
        { platform: 'tiktok', handle: profile.tiktokHandle || nestedHandle('tiktok', 'tiktokHandle') || pairedInfluencer.tiktokHandle },
        { platform: 'youtube', handle: profile.youtubeHandle || nestedHandle('youtube', 'youtubeHandle') || pairedInfluencer.youtubeAccountHandle },
        { platform: 'facebook', handle: profile.facebookHandle || profile.fbHandle || nestedHandle('facebook', 'facebookHandle') || nestedHandle('facebook', 'username') || pairedInfluencer.facebookAccountHandle },
        { platform: 'linkedin', handle: profile.linkedinHandle || nestedHandle('linkedin', 'linkedinHandle') || pairedInfluencer.linkedinHandle },
        { platform: 'twitter', handle: profile.twitterHandle || nestedHandle('twitter', 'twitterHandle') || pairedInfluencer.twitterHandle },
        { platform: 'xiaohongshu', handle: profile.xhsHandle || nestedHandle('xiaohongshu', 'xhsHandle') || pairedInfluencer.xhsHandle },
        { platform: 'lemon8', handle: profile.lemon8Handle || profile.lemonHandle }
      ]
      accounts.unshift({
        platform: pairedInfluencer.platform,
        handle: pairedInfluencer.displayHandle || pairedInfluencer.instagramHandle
      })

      const seen = new Set()
      return accounts.filter(account => {
        if (!account.handle) return false
        account.handle = String(account.handle).trim().replace(/^@+/, '')
        if (!account.handle) return false
        const key = `${account.platform}:${account.handle.toLowerCase()}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    createPairedHandleOption(pairedInfluencer, account, profileHandles) {
      const findHandle = platform => {
        const match = profileHandles.find(profileHandle => profileHandle.platform === platform)
        return match ? match.handle : ''
      }
      return Object.assign({}, pairedInfluencer, {
        platform: account.platform,
        // Legacy selectors use instagramHandle as their common option value for every platform.
        instagramHandle: account.handle,
        displayHandle: account.handle,
        originalInstagramHandle: findHandle('instagram') || pairedInfluencer.originalInstagramHandle,
        linkedinHandle: account.platform === 'linkedin' ? account.handle : findHandle('linkedin'),
        twitterHandle: account.platform === 'twitter' ? account.handle : findHandle('twitter')
      })
    },
    getAccountOptionValue(account) {
      if (!account || typeof account !== 'object') return account
      const platform = String(account.platform || 'instagram').trim().toLowerCase()
      const handle = String(account.instagramHandle || account.displayHandle || '').trim().replace(/^@+/, '').toLowerCase()
      return `${account.pairingID || account.influencerID || ''}:${platform}:${handle}`
    },
    resolveSelectedAccount(value) {
      if (value && typeof value === 'object') return value
      const handle = String(value || '').trim().replace(/^@+/, '').toLowerCase()
      const matches = this.pairedInfluencers.filter(account =>
        String(account.instagramHandle || '').trim().replace(/^@+/, '').toLowerCase() === handle)
      if (matches.length > 1) throw new Error('Please select the specific creator account from the list.')
      return matches[0]
    },
    async expandPairedInfluencerHandles(influencers) {
      this.pairedInfluencersLoading = true
      try {
        const expandedGroups = await Promise.all(influencers.map(async pairedInfluencer => {
          let profile = {}
          if (pairedInfluencer.influencerID) {
            try {
              const response = await influencerAPIs.getInfluencer(pairedInfluencer.influencerID)
              profile = response && response.influencer ? response.influencer : response
            } catch (error) {
              console.error(`Unable to load connected accounts for influencer ${pairedInfluencer.influencerID}`, error)
            }
          }
          const profileHandles = this.getInfluencerProfileHandles(profile || {}, pairedInfluencer)
          if (!profileHandles.length) return [pairedInfluencer]
          return profileHandles.map(account => this.createPairedHandleOption(pairedInfluencer, account, profileHandles))
        }))
        const seen = new Set()
        return expandedGroups.reduce((options, group) => options.concat(group), []).filter(option => {
          const key = `${option.pairingID || option.influencerID}:${option.platform}:${String(option.displayHandle).toLowerCase()}`
          if (seen.has(key)) return false
          seen.add(key)
          return true
        })
      } finally {
        this.pairedInfluencersLoading = false
      }
    },
    /**
     * Handle the post selection from postview
     */
    async postSelected(post) {
      try {
        this.noOfnewPostAdded++;
        if (this.postViewType === 'hashtag_search') {
          return this.addPostToCampaign(post.permalink, this.campaign.id);
        }
        this.loading = true;
        const campaignID = this.campaign.id;
        const body = {
          campaignID,
          source: 'graph_api',
          post,
          postType: this.postType
        };
        await campaignAPIs.addPostToCampaign(body);
        this.$emit('done')
        this.$swal({
          type: 'success',
          text: 'New post is added to this campaign.'
        });
      } catch (error) {
        console.error(error.message);
        this.$swal({
          type: 'warning',
          text: 'Fail to add post to this campaign'
        });
      } finally {
        this.loading = false;
      }
    },
    async addPostToCampaign(url, campaignID) {
      try {
        this.loading = true;
        await campaignAPIs.addPostToCampaign({ url, campaignID, postId: this.postID || '', postType: this.postType, typeName: this.postTypeName });
        this.$emit('done')
        this.$swal({
          type: 'success',
          text: 'New post is added to this campaign.'
        });
        if (this.postID) {
          const data = {
            url,
            lockSubmission: true,
            dateConfirmed: true
          };
          await postAPIs.updatePostForPayout(this.postID, data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async addStoryInsightsManually() {
      try {
        let selectedHandle = this.storyIgHandle
        let pairingID = null
        let platform = 'instagram'
        if (this.storyIgHandle === '' || this.storyIgHandle === null) {
          this.$swal({
            type: 'error',
            text: 'Instagram username is required'
          })
          return
        }
        if (!this.storyCountry) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        }
        if (!this.storyMediaUrl) {
          this.$swal({
            type: 'error',
            text: 'Story Media URL is required'
          })
          return
        }
        if (!this.storyLiveDate) {
          this.$swal({
            type: 'error',
            text: 'Live Date is required'
          })
          return
        }
        const selectedAccount = this.resolveSelectedAccount(this.storyIgHandle)
        if (selectedAccount) {
          platform = selectedAccount.platform || platform
          pairingID = selectedAccount.pairingID || null
          selectedHandle = selectedAccount.instagramHandle
        }
        await this.invokePayoutCheck(selectedHandle)
        if (!this.checkLiveDate(this.storyLiveDate)) return
        selectedHandle = utils.func.espaceHandleSign(selectedHandle)
        this.loading = true;
        let reports = await campaignAPIs.addStoryInsights(this.campaignData.id,
        this.postID || '',
        pairingID,
        selectedHandle,
        this.storyCountry,
        platform,
        this.storyInsights,
        this.storyMediaUrl,
        this.storyLiveDate,
        this.postType,
        this.postTypeName);
        this.$emit('addedReport', reports)
        this.$swal({
          type: 'success',
          text: 'Story Insights are added.'
        });
        this.storyMediaUrl = '';
        this.storyIgHandle = '';
        this.storyInsights = {
          impressions: '',
          story_likes: '',
          reach: '',
          replies: '',
          exits: '',
          taps_back: '',
          taps_forward: '',
          shares: '',
          link_clicks: '',
          sticker_taps: ''
        }
        this.storyCountry = ''
        this.close()
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: 'Failed to add story insights'
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async addPostInsightsManually() {
      try {
        let platform = 'instagram'
        let selectedHandle = this.postIgHandle
        let pairingID = null
        if (this.postIgHandle === '' || this.postIgHandle === null) {
          this.$swal({
            type: 'error',
            text: 'Instagram username is required'
          })
          return
        }
        if (!this.postCountry) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        }
        if (!this.postURL) {
          this.$swal({
            type: 'error',
            text: 'Post URL is required'
          })
          return
        }
        if (!this.postLiveDate) {
          this.$swal({
            type: 'error',
            text: 'Live Date is required'
          })
          return
        }

        let selectedAccount = typeof this.postIgHandle === 'object' ? this.postIgHandle : null
        if (!selectedAccount) {
          const handle = String(this.postIgHandle).trim().replace(/^@+/, '').toLowerCase()
          const matches = this.pairedInfluencers.filter(account =>
            String(account.instagramHandle || '').trim().replace(/^@+/, '').toLowerCase() === handle)
          if (matches.length > 1) {
            this.$swal({ type: 'error', text: 'Please select the specific creator account from the list.' })
            return
          }
          selectedAccount = matches[0]
        }
        if (selectedAccount) {
          platform = selectedAccount.platform || 'instagram'
          pairingID = selectedAccount.pairingID || null
          selectedHandle = selectedAccount.instagramHandle
        }
        if (this.postURL === '') {
          this.$swal({
            type: 'error',
            text: 'PostURL is required'
          })
          return
        }
        await this.invokePayoutCheck(selectedHandle)
        if (!this.checkLiveDate(this.postLiveDate)) return

        this.loading = true;
        if (this.postID) {
          const data = {
            url: this.postURL,
            lockSubmission: true,
            dateConfirmed: true
          };
          await postAPIs.updatePostForPayout(this.postID, data);
        }
        if (this.postType === 'IGR') {
          this.inputtedInsights.plays = campaignHelper.formatTikTokPlayTime(this.reelTotalPlayTime)
        }
        selectedHandle = utils.func.espaceHandleSign(selectedHandle)
        let reports = await campaignAPIs.addPostInsights(this.campaignData.id, this.postID || '',
        pairingID,
        selectedHandle,
        this.postCountry,
        platform,
        this.postInsights,
        this.inputtedInsights,
        this.postURL,
        this.postImageURL,
        this.postLiveDate,
        this.postType,
        this.postTypeName);
        this.$emit('addedReport', reports)
        this.$swal({
          type: 'success',
          text: 'Post Insights are added.'
        });
        this.postIgHandle = ''
        this.postURL = ''
        this.postImageURL = ''
        this.postCountry = ''
        this.postInsights = {
          outreach: '',
          engagement_rate: '',
          like_count: '',
          comment_count: ''
        }
        this.inputtedInsights = {
          saved: '',
          shares: '',
          reposts: '',
          views: '',
          reach: '',
          impressions: '',
          watches: '',
          plays: ''
        }
        this.reelTotalPlayTime = {
          day: '',
          hour: '',
          minute: '',
          second: ''
        }
        this.close()
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: error
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async addYoutubeInsightsManually() {
      try {
        let platform = 'youtube'
        let pairingID = null
        if (this.youtubeHandle === '' || this.youtubeHandle === null) {
          this.$swal({
            type: 'error',
            text: 'Youtube username is required'
          })
          return
        }
        if (!this.youtubeCountry) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        }
        if (!this.youtubeURL) {
          this.$swal({
            type: 'error',
            text: 'Youtube Video URL is required'
          })
          return
        }
        if (!this.youtubeLiveDate) {
          this.$swal({
            type: 'error',
            text: 'Live Date is required'
          })
          return
        }
        if (typeof this.youtubeHandle === 'object') {
          // if come from selection
          platform = this.youtubeHandle.platform
          if (this.youtubeHandle.pairingID) {
            pairingID = this.youtubeHandle.pairingID
          }
          this.youtubeHandle = this.youtubeHandle.instagramHandle
        }
        // await this.invokePayoutCheck(this.postIgHandle)
        if (!this.checkLiveDate(this.youtubeLiveDate)) return

        this.loading = true;
        if (this.postID) {
          const data = {
            url: this.postURL,
            lockSubmission: true,
            dateConfirmed: true
          };
          await postAPIs.updatePostForPayout(this.postID, data);
        }
        this.youtubeHandle = utils.func.espaceHandleSignNoLower(this.youtubeHandle)
        let reports = await campaignAPIs.addYoutubePostInsights(this.campaignData.id,
        this.postID || '',
        pairingID,
        this.youtubeHandle,
        this.youtubeCountry,
        platform,
        this.youtubeInsights,
        this.youtubeInputtedInsights,
        this.youtubeURL,
        this.youtubeLiveDate,
        this.postType,
        this.postTypeName);
        this.$emit('addedReport', reports)
        this.$swal({
          type: 'success',
          text: 'Post Insights are added.'
        });
        this.youtubeHandle = ''
        this.youtubeURL = ''
        this.youtubeCountry = ''
        this.youtubeInsights = {
          outreach: '',
          engagement_rate: '',
          like_count: '',
          comment_count: '',
          views: ''
        }
        this.youtubeInputtedInsights = {
          impressions: '',
          unique_viewers: '',
          watches: ''
        }
        this.close()
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: error
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async addTikTokInsightsManually() {
      try {
        let selectedHandle = this.tikTokHandle
        let platform = 'tiktok'
        let pairingID = null
        if (this.tikTokHandle === '' || this.tikTokHandle === null) {
          this.$swal({
            type: 'error',
            text: 'TikTok username is required'
          })
          return
        }
        if (!this.tiktokCountry) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        }
        if (!this.tikTokPostURL) {
          this.$swal({
            type: 'error',
            text: 'TikTok Post URL is required'
          })
          return
        }
        if (!this.tiktokLiveDate) {
          this.$swal({
            type: 'error',
            text: 'Live Date is required'
          })
          return
        }
        const selectedAccount = this.resolveSelectedAccount(this.tikTokHandle)
        if (selectedAccount) {
          platform = selectedAccount.platform || platform
          pairingID = selectedAccount.pairingID || null
          selectedHandle = selectedAccount.instagramHandle
        }
        if (this.tikTokPostURL === '') {
          this.$swal({
            type: 'error',
            text: 'TikTok PostURL is required'
          })
          return
        }
        await this.invokePayoutCheck(selectedHandle, 'tiktok')
        if (!this.checkLiveDate(this.tiktokLiveDate)) return
        this.loading = true;
        // if (this.postID) {
        //   const data = {
        //     url: this.tikTokPostURL,
        //     lockSubmission: true
        //   };
        //   await postAPIs.updatePostForPayout(this.postID, data);
        // }
        this.tikTokInputtedInsights.plays = campaignHelper.formatTikTokPlayTime(this.totalPlayTime)
        selectedHandle = utils.func.espaceHandleSign(selectedHandle)
        let reports = await campaignAPIs.addTikTokInsights(this.campaignData.id, pairingID, selectedHandle, this.tiktokCountry, platform, this.tikTokInsights, this.tikTokInputtedInsights, this.tikTokPostURL, this.tiktokLiveDate, this.postType, this.postID || '');
        this.$emit('addedReport', reports)
        this.$swal({
          type: 'success',
          text: 'TikTok Insights are added.'
        });
        this.tikTokHandle = ''
        this.tikTokPostURL = ''
        this.tiktokCountry = ''
        this.tikTokInsights = {
          engagement_rate: '',
          outreach: '',
          like_count: '',
          comment_count: '',
          views: '',
          shares: ''
        }
        this.tikTokInputtedInsights = {
          outreach: '',
          engagement_rate: '',
          reach: '',
          impressions: '',
          watches: '',
          plays: '',
          watchedFullVideo: '',
          photo_views: ''
        }
        this.close()
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: error
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async addFbInsightsManually() {
      try {
        let platform = 'facebook'
        let pairingID = null
        if (this.fbHandle === '' || this.fbHandle === null) {
          this.$swal({
            type: 'error',
            text: 'Facebook username is required'
          })
          return
        }
        if (!this.fbCountry) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        } else if (!this.fbMediaUrl) {
          this.$swal({
            type: 'error',
            text: 'Facebook Media URL is required'
          })
          return
        } else if (this.fbLiveDate === '') {
          this.$swal({
            type: 'error',
            text: 'Live Date is required'
          })
          return
        }
        if (typeof this.fbHandle === 'object') {
          // if come from selection
          platform = this.fbHandle.platform
          if (this.fbHandle.pairingID) {
            pairingID = this.fbHandle.pairingID
          }
          this.fbHandle = this.fbHandle.instagramHandle
        }
        // let chkRet = await this.checkFbInf(this.fbHandle)
        // if (!chkRet) {
        //   this.$swal({
        //     type: 'warning',
        //     text: 'Facebook influencer not exists.'
        //   })
        //   return
        // }
        await this.invokePayoutCheck(this.fbHandle)
        if (!this.checkLiveDate(this.fbLiveDate)) return
        this.fbHandle = utils.func.espaceHandleSign(this.fbHandle)
        this.loading = true;
        let reports = await campaignAPIs.addFbInsights(this.campaignData.id,
        this.postID || '',
        pairingID,
        this.fbHandle,
        this.fbCountry,
        platform,
        this.fbInsights,
        this.fbMediaUrl,
        this.fbLiveDate,
        this.postType,
        this.postTypeName);
        this.$emit('addedReport', reports)
        this.$swal({
          type: 'success',
          text: 'Facebook Insights are added.'
        });
        this.fbMediaUrl = '';
        this.fbHandle = '';
        this.fbCountry = '';
        this.fbInsights = {
          outreach: '',
          like_count: '',
          comment_count: ''
        }
        this.close()
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: 'Failed to add Facebook insights'
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async addXHSInsightsManually() {
      try {
        let platform = 'xiaohongshu'
        let pairingID = null
        if (this.xhsHandle === '' || this.xhsHandle === null) {
          this.$swal({
            type: 'error',
            text: 'XHS username is required'
          })
          return
        } else if (!this.xhsCountry) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        } else if (this.xhsLink === '') {
          this.$swal({
            type: 'error',
            text: 'XHS Link is required'
          })
          return
        } else if (this.xhsLiveDate === '') {
          this.$swal({
            type: 'error',
            text: 'Live Date is required'
          })
          return
        } else if (this.xhsFollowers === '') {
          this.$swal({
            type: 'error',
            text: 'XHS followers is required'
          })
          return
        }
        if (typeof this.xhsHandle === 'object') {
          // if come from selection
          pairingID = this.xhsHandle.pairingID
          this.xhsHandle = this.xhsHandle.instagramHandle
          this.xhsID = this.xhsHandle.xhsID
        }
        let chkRet = await this.checkXHSInf(this.xhsHandle)
        if (!chkRet) {
          // this.$swal({
          //   type: 'warning',
          //   text: 'XHS influencer not exists.'
          // })
          // return
        } else {
          if (chkRet.xiaohongshu) {
            if (!this.xhsID) {
              this.xhsID = chkRet.xiaohongshu.xhsID
            }
          }
        }
        await this.invokePayoutCheck(this.xhsHandle)
        if (!this.checkLiveDate(this.xhsLiveDate)) return
        this.loading = true;
        const multipleMediaUrls = this.media ? this.xhsMediaUrl.map(m => m.file) : [];
        let reports = []
        this.xhsHandle = utils.func.espaceHandleSignNoLower(this.xhsHandle)
        for (let multiMedia of multipleMediaUrls) {
          reports = await campaignAPIs.addXHSInsights(this.campaignData.id,
          this.postID || '',
          pairingID,
          this.xhsHandle,
          this.xhsCountry,
          platform,
          this.xhsID,
          this.xhsLink,
          this.xhsFollowers,
          this.xhsInsights,
          multiMedia,
          this.xhsLiveDate,
          this.postType,
          this.postTypeName);
        }
        this.$emit('addedReport', reports)
        this.$swal({
          type: 'success',
          text: 'XHS Insights are added.'
        });
        this.xhsMediaUrl = '';
        this.xhsLink = '';
        this.xhsHandle = '';
        this.xhsCountry = '';
        this.xhsFollowers = '';
        this.xhsInsights = {
          outreach: '',
          like_count: '',
          comment_count: '',
          views: '',
          watches: '',
          shares: '',
          bookmarks: ''
        }
        this.close()
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: 'Failed to add XHS insights'
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async addLemonInsightsManually() {
      try {
        let platform = 'lemon8'
        let pairingID = null
        if (this.lemonHandle === '' || this.lemonHandle === null) {
          this.$swal({
            type: 'error',
            text: 'Lemon8 username is required'
          })
          return
        } else if (!this.lemonCountry) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        } else if (this.lemonLink === '') {
          this.$swal({
            type: 'error',
            text: 'Lemon Link is required'
          })
          return
        } else if (this.lemonLiveDate === '') {
          this.$swal({
            type: 'error',
            text: 'Live Date is required'
          })
          return
        } else if (this.lemonFollowers === '') {
          this.$swal({
            type: 'error',
            text: 'Lemon8 followers is required'
          })
          return
        } else if (!this.lemonMediaUrl.length) {
          this.$swal({
            type: 'error',
            text: 'Media is required'
          })
          return
        }
        if (typeof this.lemonHandle === 'object') {
          // if come from selection
          this.lemonHandle = this.lemonHandle.instagramHandle
          if (this.lemonHandle.pairingID) {
            pairingID = this.lemonHandle.pairingID
          }
          this.lemonID = this.lemonHandle.lemonID
        }
        if (!this.checkLiveDate(this.lemonLiveDate)) return
        this.loading = true;
        const multipleMediaUrls = this.media ? this.lemonMediaUrl.map(m => m.file) : [];
        let reports = []
        this.lemonHandle = utils.func.espaceHandleSignNoLower(this.lemonHandle)
        for (let multiMedia of multipleMediaUrls) {
          reports = await campaignAPIs.addLemonInsights(this.campaignData.id,
          this.postID || '',
          pairingID,
          this.lemonHandle,
          this.lemonCountry,
          platform,
          this.lemonID,
          this.lemonLink,
          this.lemonFollowers,
          this.lemonInsights,
          multiMedia,
          this.lemonLiveDate,
          this.postType,
          this.postTypeName);
        }
        this.$emit('addedReport', reports)
        this.$swal({
          type: 'success',
          text: 'Lemon8 Insights are added.'
        });
        this.lemonMediaUrl = '';
        this.lemonLink = '';
        this.lemonHandle = '';
        this.lemonCountry = '';
        this.lemonFollowers = '';
        this.lemonInsights = {
          outreach: '',
          like_count: '',
          comment_count: '',
          views: '',
          watches: '',
          shares: '',
          bookmarks: ''
        }
        this.close()
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: 'Failed to add Lemon8 insights'
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async addOtherInsightsManually() {
      try {
        let platform = this.postType === 'LIP' ? 'linkedin' : (this.postType === 'XTP' ? 'twitter' : 'others')
        let pairingID = null
        if (this.otherHandle === '' || this.otherHandle === null) {
          this.$swal({
            type: 'error',
            text: 'username is required'
          })
          return
        }
        if (!this.otherCountry) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        }
        if (this.otherPostURL === '') {
          this.$swal({
            type: 'error',
            text: 'PostURL is required'
          })
          return
        }
        if (this.otherMediaUrl === '' && this.postType !== 'XTP') {
          this.$swal({
            type: 'error',
            text: 'Media is required'
          })
          return
        }
        const selectedInfluencer = typeof this.otherHandle === 'object'
          ? this.otherHandle
          : this.pairedInfluencers.find(influencer => {
            const selectedHandle = this.postType === 'LIP'
              ? influencer.linkedinHandle
              : (this.postType === 'XTP' ? influencer.twitterHandle : influencer.instagramHandle)
            return selectedHandle === this.otherHandle
          })
        if (selectedInfluencer) {
          // Preserve the pairing even when Vuetify returns the item's value
          // instead of the full object (for example after typing to filter).
          this.otherHandle = this.postType === 'LIP'
            ? (selectedInfluencer.linkedinHandle || selectedInfluencer.instagramHandle)
            : (this.postType === 'XTP' ? (selectedInfluencer.twitterHandle || selectedInfluencer.instagramHandle) : selectedInfluencer.instagramHandle)
          platform = this.postType === 'LIP' ? 'linkedin' : (this.postType === 'XTP' ? 'twitter' : selectedInfluencer.platform)
          if (selectedInfluencer.pairingID) {
            pairingID = selectedInfluencer.pairingID
          }
        }
        await this.invokePayoutCheck(this.otherHandle, platform, pairingID)
        if (!this.checkLiveDate(this.otherLiveDate)) return
        this.otherHandle = utils.func.espaceHandleSign(this.otherHandle)
        this.loading = true;
        const multipleMediaUrls = this.media && this.otherMediaUrl.length
          ? this.otherMediaUrl.map(m => m.file)
          : [null];
        // if (this.postID) {
        //   const data = {
        //     url: this.tikTokPostURL,
        //     lockSubmission: true
        //   };
        //   await postAPIs.updatePostForPayout(this.postID, data);
        // }
        if (this.postType !== 'LIP' && this.postType !== 'XTP' && this.otherTotalPlayTime) {
          this.otherInsights.plays = campaignHelper.formatTikTokPlayTime(this.otherTotalPlayTime)
        } else if (this.postType === 'LIP' || this.postType === 'XTP') {
          this.otherInsights.plays = ''
          this.otherInsights.watches = ''
          this.otherInsights.views = ''
        }
        let reports = []
        for (let multiMedia of multipleMediaUrls) {
          reports = await campaignAPIs.addOtherInsights(this.campaignData.id,
          pairingID,
          this.otherHandle,
          this.otherCountry,
          platform,
          this.otherInsights,
          this.otherPostURL,
          multiMedia,
          this.otherLiveDate,
          this.postType,
          this.typeName,
          this.postID || '');
          this.$emit('addedReport', reports)
        }
        this.$swal({
          type: 'success',
          text: 'Other Insights are added.'
        });
        this.otherHandle = ''
        this.otherCountry = ''
        this.otherPostURL = ''
        this.otherInsights = {
          engagement_rate: '',
          outreach: '',
          like_count: '',
          comment_count: '',
          impressions: '',
          views: '',
          shares: '',
          reach: '',
          saved: '',
          watches: '',
          plays: '',
          video_views: '',
          profile_viewers: ''
        }
        this.close()
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: error
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    // async addMultipleContentsManually() {
    //   try {
    //     if (this.multipleIgHandle === '') {
    //       this.$swal({
    //         type: 'error',
    //         text: 'Instagram username is required'
    //       })
    //       return
    //     }
    //     this.loading = true;
    //     let multipleMediaUrls = []
    //     this.gdriveFiles.map(gd => {
    //       multipleMediaUrls.push({media_type: gd.media_type, embed_url: gd.embedURL})
    //     })
    //     let campaignName = this.campaignData ? this.campaignData.name : 'Unknown Campaign'
    //     await campaignAPIs.addMultipleContents(this.campaignData.id, campaignName, this.multipleIgHandle, multipleMediaUrls);
    //     this.$swal({
    //       type: 'success',
    //       text: 'Multiple Contents are added.'
    //     });
    //     this.gdriveFiles = [];
    //     this.multipleIgHandle = '';
    //     this.close()
    //   } catch (error) {
    //     console.error(error);
    //     this.$swal({
    //       type: 'error',
    //       text: 'Failed to multiple contents'
    //     });
    //     this.loading = false;
    //     this.close()
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    async processMultipleUpload(error, result) {
      try {
        this.loading = true;
        if (!error && result && result.event === 'success') {
          let INFO = result.info
          let multipleMediaUrls = [{media_type: INFO.resource_type, public_id: INFO.public_id, embed_url: INFO.secure_url, thumbnail_url: INFO.thumbnail_url}]
          // let campaignName = this.campaignData ? this.campaignData.name : 'Unknown Campaign'
          let reports = await campaignAPIs.addMultipleContents(this.campaignData.id, this.multipleIgHandle, multipleMediaUrls, this.postType, this.multipleLiveDate, this.postID || '');
          this.$emit('addedReport', reports)
          this.$swal({
            type: 'success',
            text: 'Multiple Contents are added.'
          });
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: 'Failed to multiple contents'
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async saveMutlipleContents() {
      try {
        let platform = 'instagram'
        this.loading = true;
        let pairingID = null
        if (this.multipleIgHandle.pairingID) {
          pairingID = this.multipleIgHandle.pairingID
          this.multipleIgHandle = this.multipleIgHandle.instagramHandle
        }
        this.multipleIgHandle = utils.func.espaceHandleSign(this.multipleIgHandle)
        const multipleMediaUrls = this.media ? this.media.map(m => m.file) : [];
        for (let multiMedia of multipleMediaUrls) {
          // let campaignName = this.campaignData ? this.campaignData.name : 'Unknown Campaign'
          let reports = await campaignAPIs.addMultipleContents(this.campaignData.id,
          pairingID,
          this.multipleIgHandle,
          this.multipleCountry,
          platform,
          multiMedia,
          this.postType,
          this.postTypeName,
          this.multipleLiveDate,
          this.postID || '');
          this.$emit('addedReport', reports)
        }
        this.$swal({
          type: 'success',
          text: 'Multiple Contents are added.'
        });
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.$swal({
          type: 'error',
          text: 'Failed to multiple contents'
        });
        this.loading = false;
        this.close()
      } finally {
        this.loading = false;
      }
    },
    async gDrivePicked(data) {
      data.map(m => this.gdriveFiles.push(m))
    },
    async deletegDriveFile(index) {
      this.gdriveFiles.splice(index, 1);
    },
    clearEnterPost() {
      this.storyIgHandle = ''
      this.storyMediaUrl = ''
      this.tikTokHandle = ''
      this.tikTokPostURL = ''
      this.postIgHandle = ''
      this.postImageURL = ''
      this.postURL = ''
      this.url = ''
      this.panel = []
    },
    async openCloudinaryWidget(folder) {
      // init cloudinary object
      await this.$store.dispatch('campaign/getCldSignature', {
        filters: {
          folder,
          source: 'uw' // upload widget
        }
      })
      this.myWidget = window.cloudinary.createUploadWidget(
        { cloudName: this.cldConfig.CLOUD_NAME,
          uploadPreset: this.cldConfig.UPLOAD_PRESET,
          folder,
          thumbnailTransformation: [{ width: 320, height: 320, crop: 'fill' }],
          sources: ['local', 'url', 'google_drive', 'facebook', 'instagram'],
          api_key: this.cldConfig.API_KEY,
          uploadSignature: this.cldSignature.signature,
          uploadSignatureTimestamp: this.cldSignature.timestamp,
          prepareUploadParams: async (cb, params) => {
            // if headers changed especially for google drive, regenerate signature
            params = [].concat(params)
            for (let [index, param] of params.entries()) {
              if (param.headers) {
                await this.$store.dispatch('campaign/getCldSignature', {
                  filters: {
                    filename_override: param.filename_override,
                    folder: param.folder,
                    headers: param.headers,
                    source: 'uw',
                    timestamp: param.timestamp
                  }
                })
              }
              params[index] = Object.assign({}, {
                signature: this.cldSignature.signature
              })
            }
            cb(params.length === 1 ? params[0] : params)
          }
        },
        this.processMultipleUpload
      );
      this.myWidget.open()
    },
    async openCloudinaryUpload() {
      if (this.multipleIgHandle === '') {
        this.$swal({
          type: 'error',
          text: 'Instagram username is required'
        })
        return
      }
      await this.invokePayoutCheck(this.multipleIgHandle)
      if (!this.checkLiveDate(this.multipleLiveDate)) return
      let campaignName = this.campaignData ? this.campaignData.name : 'Unknown Campaign'
      this.openCloudinaryWidget(`${utils.func.escapeCldSpecialChars(campaignName)}/@${utils.func.escapeCldSpecialChars(this.multipleIgHandle)}`)
    },
    // clickStep(step) {
    //   if (step === 1) {
    //     this.step = 1
    //     this.showPanel = ''
    //   } else if (step === 2) {
    //     if (this.postType === 'IGP' ||
    //     this.postType === 'IGC' ||
    //     this.postType === 'IGV' ||
    //     this.postType === 'IGR') {
    //       this.showPanel = 'post'
    //     } else if (this.postType === 'IGS') {
    //       this.showPanel = 'story'
    //     } else if (this.postType === 'TTP') {
    //       this.showPanel = 'tiktok'
    //     }
    //   }
    //   this.step = step
    // },
    changeContentType() {
      if (this.postType === 'IGP' ||
      this.postType === 'IGC' ||
      this.postType === 'IGV' ||
      this.postType === 'IGR') {
        this.showPanel = 'post'
      } else if (this.postType === 'IGS') {
        this.showPanel = 'story'
      } else if (this.postType === 'TTP') {
        this.showPanel = 'tiktok'
      } else if (this.postType === 'YTP') {
        this.showPanel = 'youtube'
      } else if (this.postType === 'Others') {
        this.showPanel = 'Others'
      } else if (this.postType === 'LIP') {
        this.showPanel = 'LinkedIn Post'
      } else if (this.postType === 'XTP') {
        this.showPanel = 'X (Twitter) Post'
      } else if (this.postType === 'XHS') {
        this.showPanel = 'XHS Post'
      } else if (this.postType === 'Lemon8') {
        this.showPanel = 'Lemon Post'
      } else if (this.postType === 'FBP') {
        this.showPanel = 'Facebook Post'
      }
    },
    checkLiveDate(liveDate) {
      if (!liveDate) {
        this.$swal({
          type: 'error',
          title: 'Empty Live Date',
          text: 'Please select live date'
        });
        return false
      }
      return true
    },
    async invokePayoutCheck(handle, platform = '', pairingID = null) {
      const payload = {
        handle,
        platform,
        pairingID,
        campaign: this.campaignData,
        pairedInfluencers: this.pairedInfluencers
      }
      return await campaignHelper.checkPairingPayoutConfirm(this, payload)
    },
    async checkXHSInf(xhsHandle) {
      const payload = {
        xhsHandle
      }
      let inf = await influencerAPIs.getInfluencerByXHSHandle(payload)
      if (inf) {
        if (inf.influencerID) {
          return inf
        }
      }
      return false
    },
    async checkFbInf(fbHandle) {
      const payload = {
        fbHandle
      }
      let inf = await influencerAPIs.getInfluencerByFbHandle(payload)
      if (inf) {
        if (inf.influencerID) {
          return inf
        }
      }
      return false
    },
    async mediaChanged(media) {
      this.media = Object.assign(media, [])
    },
    async xhsMediaChanged(media) {
      this.xhsMediaUrl = Object.assign(media, [])
    },
    async lemonMediaChanged(media) {
      this.lemonMediaUrl = Object.assign(media, [])
    },
    async otherMediaChanged(media) {
      this.otherMediaUrl = Object.assign(media, [])
    },
    openUploadStatsDialog(handle, postType) {
      let uploadHandle = ''
      if (typeof handle === 'object') {
        uploadHandle = handle.instagramHandle
      } else {
        uploadHandle = handle
      }
      this.aiPostType = postType
      if (this.campaignPayouts) {
        this.campaignPayouts.forEach(cPayout => {
          if (cPayout.handle === uploadHandle) {
            this.campaignPayout = cPayout
          }
        })
      }
      this.uploadStatsDialog = true
    },
    confirmedStats(statsData) {
      if (this.showPanel === 'post') {
        if (statsData.new_followers) this.inputtedInsights.reach = Number(statsData.new_followers)
        if (statsData.reached) {
          this.inputtedInsights.reach = statsData.reached
        }
        if (statsData.likes) this.postInsights.like_count = Number(statsData.likes)
        if (statsData.comments) this.postInsights.comment_count = Number(statsData.comments)
        if (statsData.bookmarks) this.inputtedInsights.saved = Number(statsData.bookmarks)
        if (statsData.shares) this.inputtedInsights.shares = Number(statsData.shares)
      }
      if (this.showPanel === 'tiktok') {
        if (statsData.new_followers) this.tikTokInputtedInsights.reach = Number(statsData.new_followers)
        if (statsData.likes) this.tikTokInsights.like_count = Number(statsData.likes)
        if (statsData.comments) this.tikTokInsights.comment_count = Number(statsData.comments)
        if (statsData.shares) this.tikTokInsights.shares = Number(statsData.shares)
        if (statsData.bookmarks) this.tikTokInputtedInsights.saved = Number(statsData.bookmarks)
        if (statsData.video_views) {
          this.tikTokInsights.views = statsData.video_views
        }
        if (statsData.total_play_time) {
          let playTimeParsed = this.parsePlayTime(statsData.total_play_time)
          if (playTimeParsed.length > 2) {
            this.totalPlayTime.hour = playTimeParsed[0]
            this.totalPlayTime.minute = playTimeParsed[1]
            this.totalPlayTime.second = playTimeParsed[2]
          }
        }
        if (statsData.average_watch_time_seconds) {
          this.tikTokInputtedInsights.watches = statsData.average_watch_time_seconds
        }
        if (statsData.watched_full_video_percentage) {
          this.tikTokInputtedInsights.watchedFullVideo = statsData.watched_full_video_percentage
        }
      }
      if (this.postType === 'IGR') {
        if (statsData.reposts != null) {
          this.inputtedInsights.reposts = Number(statsData.reposts)
        }
        if (statsData.reached) {
          this.inputtedInsights.reach = statsData.reached
        }
        if (statsData.video_views) {
          this.inputtedInsights.views = statsData.video_views
        }
        if (statsData.reel_watch_time) {
          let playTimeParsed = this.parsePlayTime(statsData.reel_watch_time)
          if (playTimeParsed.length > 2) {
            this.reelTotalPlayTime.day = playTimeParsed[0]
            this.reelTotalPlayTime.hour = playTimeParsed[1]
            this.reelTotalPlayTime.minute = playTimeParsed[2]
            this.reelTotalPlayTime.second = playTimeParsed[3]
          }
        }
        if (statsData.average_watch_time_seconds) {
          this.inputtedInsights.watches = statsData.average_watch_time_seconds
        }
      }
      if (this.showPanel === 'story') {
        if (statsData.reached) {
          this.storyInsights.reach = statsData.reached
        }
        if (statsData.replies) {
          this.storyInsights.replies = statsData.replies
        }
        if (statsData.shares) {
          this.storyInsights.shares = statsData.shares
        }
        if (statsData.link_clicks) {
          this.storyInsights.link_clicks = statsData.link_clicks
        }
        if (statsData.sticker_taps) {
          this.storyInsights.sticker_taps = statsData.sticker_taps
        }
      }
    }
  },
  watch: {
    campaign(value) {
      this.campaignData = Object.assign({}, value);
      console.log(this.campaignData)
      this.list = [];
      this.showPanel = ''
      this.postType = ''
      // this.clickStep(1)
      this.targetCountries = Object.assign([], this.countries)
      this.fetchSelectedInfluencers(value.id);
      if (this.campaignData.targetLocation) {
        if (Array.isArray(this.campaignData.targetLocation)) {
          this.targetCountries = this.targetCountries.filter(t => this.campaignData.targetLocation.includes(t.code))
        }
      }
    },
    post(newPost) {
      if (!newPost) {
        return false
      }
      this.clearEnterPost()
      let ighandle = ''
      let isTikTok = false
      if (newPost.submitedBy) {
        if (newPost.submitedBy.tiktokHandle) {
          ighandle = utils.func.espaceHandleSign(newPost.submitedBy.tiktokHandle)
          isTikTok = true
        } else {
          ighandle = utils.func.espaceHandleSign(newPost.submitedBy.instagramHandle)
        }
      }
      const mediaURL = newPost.images.length > 0 ? newPost.images[0].url : ''
      const postURL = newPost.postURL !== undefined ? newPost.postURL : ''
      if (newPost.postDate !== undefined) {
        this.storyLiveDate = newPost.postDate
        this.postLiveDate = newPost.postDate
      }
      if (newPost.type !== undefined) {
        if (newPost.type === 'story') {
          // if story
          if (isTikTok) {
            this.tikTokHandle = utils.func.espaceHandleSign(ighandle)
            this.tikTokPostURL = mediaURL
            this.panel = [4]
          } else {
            this.storyIgHandle = utils.func.espaceHandleSign(ighandle)
            this.storyMediaUrl = mediaURL
            this.panel = [2]
          }
        } else if (newPost.type === 'post/carousel' ||
        newPost.type === 'video' ||
        newPost.type === 'post' ||
        newPost.type === 'carousel' ||
        newPost.type === 'reel' ||
        newPost.type === 'tiktok' ||
        newPost.type === 'youtube' ||
        newPost.type === 'facebook') {
          // if posts
          if (isTikTok) {
            this.tikTokHandle = utils.func.espaceHandleSign(ighandle)
            this.tikTokPostURL = mediaURL
            this.panel = [4]
          } else {
            this.postIgHandle = utils.func.espaceHandleSign(ighandle)
            // this.multipleIgHandle = ighandle
            this.postImageURL = mediaURL
            this.postURL = postURL
            this.url = postURL
            this.panel = [3]
          }
        }
      }
    }
  }
};
</script>
<style scoped>
  .btn-gdrive-del {
    position: absolute;
    right: 0;
    top: -10px;
    border-radius: 100%;
    min-width: 28px!important;
  }
</style>



// WEBPACK FOOTER //
// AddPostToCampaign.vue?631cdec4